import Flight from "./Flight";

export default Flight;
